module.exports = {
    hasCompontentsPage: true,
    hasAppCheck: false,
    functions: {
        BASE_URL: 'https://staging.timeworx.io',
        GET_IN_TOUCH: 'api/getInTouch',
        ALPHA_REGISTRATION: 'api/alphaRegistration',
        ALLOWLIST_REGISTRATION: 'api/allowlistRegistration'
    },
}